import { Reveal } from "./Reveal";
import { TESTIMONIALS, CONTACT } from "@/data";
import { Star, Quote, ArrowUpRight, PenLine } from "lucide-react";

const GoogleG = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.5 29.6 2.5 24 2.5 12.1 2.5 2.5 12.1 2.5 24S12.1 45.5 24 45.5 45.5 35.9 45.5 24c0-1.2-.1-2.3-.4-3.5z"/>
    <path fill="#FF3D00" d="M4.7 14.7l6.6 4.8C13.1 15.2 18.1 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 4.5 29.6 2.5 24 2.5 15.6 2.5 8.3 7.3 4.7 14.7z"/>
    <path fill="#4CAF50" d="M24 45.5c5.5 0 10.4-1.9 14.1-5.2l-6.5-5.5c-2 1.5-4.7 2.7-7.6 2.7-5.2 0-9.6-3.3-11.2-8l-6.6 5.1C7.3 38.6 15 45.5 24 45.5z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l6.5 5.5C39.9 40.7 45.5 33.5 45.5 24c0-1.2-.1-2.3-.4-3.5z"/>
  </svg>
);

export const Testimonials = () => (
  <section id="reviews" className="bg-cream py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-rust">Verified Reviews</span>
          <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} size={15} className="fill-rust text-rust" />)}</div>
        </div>
        <h2 className="mt-5 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-2xl leading-[0.95]">
          What the neighbors are saying.
        </h2>
      </Reveal>

      <div className="mt-16 max-w-2xl">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure data-testid={`testimonial-${i}`} className="bg-surface h-full p-8 lg:p-10 border border-ink/10 flex flex-col">
              <div className="flex items-center gap-1 mb-1">{[...Array(5)].map((_, s) => <Star key={s} size={16} className="fill-rust text-rust" />)}</div>
              <Quote size={28} className="text-rust" />
              <blockquote className="mt-6 text-lg text-ink/85 leading-relaxed flex-1">"{t.body}"</blockquote>
              <figcaption className="mt-8 pt-6 border-t border-ink/10 flex items-center gap-3">
                <span className="w-10 h-10 bg-ink text-paper grid place-items-center font-display font-bold">{t.name[0]}</span>
                <div>
                  <p className="font-semibold text-ink">{t.name}</p>
                  <p className="font-mono text-xs text-ink/50">{t.when}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 border border-ink/10 bg-surface p-6 lg:p-8">
          <div className="flex items-center gap-3 flex-1">
            <GoogleG size={28} />
            <p className="text-ink/70">See every review — and share yours — on our <span className="font-semibold text-ink">Google Business Profile</span>.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href={CONTACT.googleReviewUrl} target="_blank" rel="noopener noreferrer" data-testid="read-google-reviews"
              className="inline-flex items-center justify-center gap-2 bg-ink text-paper px-6 py-3 font-semibold hover:bg-rust transition-colors">
              Read our Google Reviews <ArrowUpRight size={18} />
            </a>
            <a href={CONTACT.googleWriteReviewUrl} target="_blank" rel="noopener noreferrer" data-testid="leave-google-review"
              className="inline-flex items-center justify-center gap-2 border border-ink/20 text-ink px-6 py-3 font-semibold hover:border-rust hover:text-rust transition-colors">
              Leave a Review <PenLine size={16} />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
